module.exports = __webpack_public_path__ + "static/media/phone1.0a419211.svg";